var map = {
	"./about-us/about-banner-1.jpg": 5404,
	"./about-us/about-banner-2.jpg": 2330,
	"./about-us/about-us-1.jpg": 354,
	"./about-us/about-us-2.jpg": 2498,
	"./apply/apply-banner.jpg": 5780,
	"./contact-us/contact-banner-1.jpg": 3360,
	"./contact-us/contact-email.svg": 57,
	"./contact-us/contact-us-map-mobile.jpg": 6985,
	"./contact-us/contact-us-map.jpg": 8071,
	"./footer/contact-email.svg": 4979,
	"./general/power-solution-1.png": 2458,
	"./general/power-solution-2.png": 3786,
	"./general/power-solution-3.png": 1176,
	"./general/process-icon-1.png": 7702,
	"./general/process-icon-2.png": 1,
	"./general/process-icon-3.png": 7148,
	"./general/process-icon-4.png": 5164,
	"./general/process-icon-5.png": 511,
	"./general/product-battery-black.png": 1358,
	"./general/product-battery-square-white.png": 3002,
	"./general/product-heater-black.png": 9381,
	"./general/product-inverter-square-white.png": 3672,
	"./general/product-inverter-white.png": 3231,
	"./general/product-solar-panels-black.png": 9914,
	"./general/product-solar-panels-square-white.png": 8696,
	"./general/solar-panel-tile.jpg": 9996,
	"./general/tevo-label.png": 5495,
	"./home/about-image-1.jpg": 3186,
	"./home/home-page-banner-1.jpg": 7238,
	"./home/promotion/2023_black-friday-1.jpg": 3970,
	"./home/promotion/2023_black-friday-2.jpg": 9313,
	"./home/promotion/2023_black-friday-3.jpg": 9046,
	"./home/promotion/2023_festive-1.jpg": 3264,
	"./home/promotion/2023_festive-2.jpg": 7833,
	"./home/promotion/MRE-Battery-Promotion-Web-banner-v1.png": 1600,
	"./home/promotion/MREBatteryPromotion_Sep_2023_v2.png": 989,
	"./home/promotion/MREBatteryPromotion_Sep_2023_v3.png": 564,
	"./home/promotion/MREWebsiteBanner_Battery_October 2023.jpg": 5894,
	"./home/promotion/MREWebsiteBanner_Panels_October 2023.png": 5157,
	"./home/promotion/MREWebsiteBanner_Panels_October-2023_v2.jpg": 9000,
	"./home/promotion/MREWebsiteBanner_Thermotank.jpg": 7669,
	"./home/promotion/MRE_Thermotank_HomeBanner.png": 1367,
	"./home/promotion/MRE_solis+evo_HomeBanner.png": 90,
	"./home/promotion/longi-solar-panel-special_july-2023.jpg": 3139,
	"./logo/logo-gradient.png": 3178,
	"./logo/logo-white.png": 9429,
	"./logo/logo.png": 8050,
	"./product-range/product-banner-1.jpg": 4580,
	"./product-range/product-banner-2.jpg": 8414,
	"./register-warranty/warranty-banner-1.jpg": 9816,
	"./resources/resources-banner-1.jpg": 6271,
	"./solutions/hybrid-kit-diagram.jpg": 3885,
	"./solutions/icon-air-cooling.png": 4739,
	"./solutions/icon-entertainment.png": 5907,
	"./solutions/icon-floor-heating.png": 8209,
	"./solutions/icon-fridge.png": 8364,
	"./solutions/icon-geyser.png": 6018,
	"./solutions/icon-home-alarm.png": 2465,
	"./solutions/icon-internet.png": 876,
	"./solutions/icon-lights.png": 3171,
	"./solutions/icon-pool-pump.png": 8992,
	"./solutions/icon-stove.png": 3670,
	"./solutions/solution-info-1.jpg": 1172,
	"./solutions/solution-info-2.jpg": 9376,
	"./solutions/solution-info-3.jpg": 8178,
	"./solutions/solutions-banner-1.jpg": 9734,
	"./solutions/solutions-banner-2.jpg": 4218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;